<template>
 <div>
    <div class="row" v-show="classifyDataErrors.amountOfClassesEmpty" id="amount-of-classes-empty-description">
        <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
            Należy podać liczbę klas.
        </small>
    </div>
    <div class="row" v-show="classifyDataErrors.amountOfClassNotInRange" id="amount-of-classes-range-description">
        <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
            Liczba klas powinna zawierać się w przedziale od 1 do 255.
        </small>
    </div>
    <div class="form-group row">
        <label for="gradual-symbol-number-of-classes" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Liczba klas</label>
        <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
            <b-form-input v-model="amountOfClasses" type="number" id="gradual-symbol-number-of-classes" min="1" max="255" :class="{ 'is-invalid': classifyDataErrors.amountOfClassesEmpty || classifyDataErrors.amountOfClassNotInRange }" aria-required="true" :aria-invalid="classifyDataErrors.amountOfClassesEmpty || classifyDataErrors.amountOfClassNotInRange" :aria-describedby="classifyDataErrors.amountOfClassesEmpty ? 'amount-of-classes-empty-description' : (classifyDataErrors.amountOfClassNotInRange ? 'amount-of-classes-range-description' : '')"></b-form-input>             
        </div>
    </div>
    <div class="form-group row">
        <label for="gradual-symbol-min-color" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Kolor MIN</label>
        <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
            <color-picker v-model="minColor" id="gradual-symbol-min-color" />
        </div>
    </div>
    <div class="form-group row">
        <label for="gradual-symbol-max-color" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Kolor MAX</label>
        <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
            <color-picker v-model="maxColor" id="gradual-symbol-max-color" />
        </div>
    </div>
    <div class="row" v-show="classifyDataErrors.methodEmpty" id="method-empty-description">
        <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
            Należy wybrać metodę klasyfikacji.
        </small>
    </div>
    <div class="form-group row">
        <label for="gradual-symbol-method" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Metoda</label>
        <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
            <b-form-select v-model="method" :options="methods" id="gradual-symbol-method" :class="{ 'is-invalid': classifyDataErrors.methodEmpty }" aria-required="true" :aria-invalid="classifyDataErrors.methodEmpty" :aria-describedby="classifyDataErrors.methodEmpty ? 'method-empty-description' : ''"></b-form-select>                 
        </div>
    </div>
    <div class="row" v-show="classifyDataErrors.attributeEmpty" id="attribute-empty-description">
        <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
            Należy wybrać atrybut do klasyfikacji.
        </small>
    </div>
    <div class="form-group row">
        <label for="gradual-symbol-attribute" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Atrybut</label>
        <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
            <b-form-select v-model="selectedAttribute" :options="attributesToSelect" id="gradual-symbol-attribute"  :class="{ 'is-invalid': classifyDataErrors.attributeEmpty }" aria-required="true" :aria-invalid="classifyDataErrors.attributeEmpty" :aria-describedby="classifyDataErrors.attributeEmpty ? 'attribute-empty-description' : ''"></b-form-select>                 
        </div>
        <div class="col-md-1">
          <b-btn variant="primary" v-on:click="classify">Klasyfikuj</b-btn>
        </div>
    </div>
    <div class="table-responsive" v-if="attributeValues.length !== 0">
      <table class="table table-striped">
        <thead>
            <tr>
              <th>Od</th>
              <th>Do</th>
              <th>Kolor wypełnienia</th>
              <th>Deseń</th>
              <th>Styl obrysu</th>
              <th>Szerokość obrysu</th>
              <th>Kolor obrysu</th>
              <th>Akcje</th>
            </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in attributeValues" :key="index">
            <td>
                <span v-show="row.styleDataErrors.fromEmpty" :id="'from-empty-description-' + index">
                  <small class="text-danger">
                    Należy podać wartość przedziału od.
                  </small>
                </span>
                <span v-show="row.styleDataErrors.fromLowerThanToLastStep" :id="'from-lower-than-description-' + index">
                  <small class="text-danger">
                    Wartość od powinna być większa lub równa wartości do przedziału poprzedniego.
                  </small>
                </span>
                <b-form-input v-model="row.from" type="number" min="0" size="sm" v-if="index !== 0" class="form-control" :class="{ 'is-invalid': row.styleDataErrors.fromEmpty || row.styleDataErrors.fromLowerThanToLastStep }" :aria-required="index !== 0" :aria-invalid="row.styleDataErrors.fromEmpty || row.styleDataErrors.fromLowerThanToLastStep" :aria-describedby="row.styleDataErrors.fromEmpty ? 'from-empty-description-' + index : (row.styleDataErrors.fromLowerThanToLastStep ? 'from-lower-than-description-' + index : '')"></b-form-input>
                <span v-if="index===0" class="small">-</span>
            </td>
            <td>
              <span v-show="row.styleDataErrors.toEmpty" :id="'to-empty-description-' + index">
                <small class="text-danger">
                  Należy podać wartość przedziału do.
                </small>
              </span>
              <span v-show="row.styleDataErrors.toLowerThanFrom" :id="'to-lower-than-description-' + index">
                <small class="text-danger">
                  Wartość do powinna być większa lub równą wartości od.
                </small>
              </span>
              <b-form-input v-model="row.to" type="number" min="0.000001" size="sm" v-if="index !== 0" class="form-control" :class="{ 'is-invalid': row.styleDataErrors.toEmpty || row.styleDataErrors.toLowerThanFrom }" :aria-required="index !== 0" :aria-invalid="row.styleDataErrors.toEmpty" :aria-describedby="row.styleDataErrors.toEmpty ? 'to-empty-description-' + index : ''"></b-form-input>
              <span v-if="index===0" class="small">{{row.to}}</span>
            </td>
            <td><color-picker v-model="row.fillColor" size="sm"/></td>
            <td>
              <span v-show="row.styleDataErrors.incorrectFileFormat" :id="'incorrect-file-format-description' + index">
                <small class="text-danger">
                  Wybrano nieprawidłowy format pliku. Dopuszczalny format pliku to png.
                </small>
              </span>
              <b-form-file v-model="row.designFileBuffer" accept="image/png" size="sm" :class="{ 'is-invalid': row.styleDataErrors.incorrectFileFormat }" :aria-invalid="row.styleDataErrors.incorrectFileFormat" :aria-describedby="row.styleDataErrors.incorrectFileFormat ? 'incorrect-file-forma-description-' + index : ''" v-on:change="fileChanged($event, row)"></b-form-file>
              <small class="form-text text-muted" v-if="row.designFileSaved">
                Używany <a :href="row.design" download="obraz.png">plik</a>. <b-btn variant="outline-primary" size="sm" @click="setFileValue(row, null, false)">Usuń</b-btn>
              </small>
            </td>
            <td><b-form-select v-model="row.strokeStyle" :options="strokeStylesList" size="sm"></b-form-select></td>
            <td>
              <span v-show="row.styleDataErrors.strokeSizeEmpty" :id="'stroke-size-empty-description-' + index">
                <small class="text-danger">
                    Należy podać szerokość obrysu.
                </small>
              </span>
              <span v-show="row.styleDataErrors.strokeSizeNotInRange" :id="'stroke-size-range-description-' + index">
                <small class="text-danger">
                    Szerokość obrysu powinna zawierać się w przedziale od 1 do 255.
                </small>
              </span>
              <b-form-input v-model="row.strokeSize" type="number" min="1" max="255" size="sm" class="form-control" :class="{ 'is-invalid': row.styleDataErrors.strokeSizeEmpty || row.styleDataErrors.strokeSizeNotInRange }" :aria-required="row.strokeStyle !== null" :aria-invalid="row.styleDataErrors.strokeSizeEmpty || row.styleDataErrors.strokeSizeNotInRange" :aria-describedby="row.styleDataErrors.strokeSizeEmpty ? 'stroke-size-empty-description-' + index : (row.styleDataErrors.strokeSizeNotInRange ? 'stroke-size-range-description-' + index : '')"></b-form-input>
            </td>
            <td><color-picker v-model="row.strokeColor" size="sm"/></td>
            <td class="text-center"><a href="#" title="Usuń" @click="deleteRow(row)"><span class="oi oi-trash"></span></a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-row align-v="center" v-if="elementsCount > 20">
      <b-col cols="4">
        Elementów na stronie: {{ elementsOnPageStart }} - {{ elementsOnPageEnd }} / {{ elementsCount }}
      </b-col>
      <b-col cols="8">
        <b-pagination align="right" :total-rows="elementsCount" :per-page="elementsPerPage" @input="changePage">
        </b-pagination>
      </b-col>
    </b-row>
    <div v-if="selectedGradualSymbolAttribute === null">
      <b-alert show variant="info"><strong>Informacja.</strong> Nie wybrano żadnego atrybutu.</b-alert>
    </div>
    <div v-if="selectedAttributeNotSuitableForClassification === true">
      <b-alert show variant="warning"><strong>Uwaga.</strong> Wybrany atrybut nie nadaje się do klasyfikacji symbolem stopniowym.</b-alert>
    </div>
    <error-modal ref="errorModal"></error-modal>
    <loading-overlay :active.sync="loading" :is-full-page="true"></loading-overlay>
  </div>
</template>

<script>
import ColorPicker from "../../ColorPicker.vue";
import ErrorModal from "../../ErrorModal.vue";
import { Api as ApiStyle } from "../../../api/api-style.js";
import { getTimestamp, getColorsGradients, roundNumber, checkErrorMessage } from "../../../api/HelperFunctions";
import { getBase64Image } from "../../../api/HelperFunctions";
import LayerStyleStore from "../store/LayerStyleStore";
import LoadingOverlay from "vue-loading-overlay";
import VueScrollTo from 'vue-scrollto';

export default {
  name: "FormLayerStylePolygonGradualSymbol",
  props: {
    attributes: Array,
    layerId: String,
    size: String
  },
  data() {
    return {
      amountOfClasses: 2,
      minColor: { r: 0, g: 0, b: 0, a: 1 },
      maxColor: { r: 255, g: 255, b: 255, a: 1 },
      method: null,
      attributesToSelect: [],
      methods: [
        { text: "Wybierz", value: null },
        { text: "Jenksa", value: "Jenks" },
        { text: "Równe przedziały", value: "equal-interval" },
        { text: "Kwantyle", value: "quantiles" }
      ],
      strokeStylesList: [
        { text: "Wybierz", value: null },
        { text: "Kreskowany", value: [4, 4] },
        { text: "Kropkowany", value: [1, 1] },
        { text: "Ciągły", value: [1] }
      ],
      selectedAttribute: null,
      selectedGradualSymbolAttribute: null,
      selectedAttributeNotSuitableForClassification: false,
      attributeValues: [],
      classifyDataErrors: {
        amountOfClassesEmpty: false,
        amountOfClassNotInRange: false,
        methodEmpty: false,
        attributeEmpty: false
      },
      currentPage: 1,
      elementsPerPage: 20,
      elementsCount: 0,
      loading: false
    };
  },
  computed: {
    elementsOnPageStart() {
      return ((this.currentPage - 1) * this.elementsPerPage) + (this.attributeValues.length ? 1 : 0);
    },
    elementsOnPageEnd() {
      return ((this.currentPage -1) * this.elementsPerPage) + this.attributeValues.length;
    },
  },
  mounted() {
    this.attributesToSelect = [];
    this.attributesToSelect.push({ text: "Wybierz", value: null });
    if (this.attributes !== null) {
      for (let i = 0; i < this.attributes.length; ++i) {
        this.attributesToSelect.push({
          text: this.attributes[i].name ? this.attributes[i].name : this.attributes[i].description,
          value: this.attributes[i].key
        });
      }
    }
    //Pobranie danych z obiektu przechowującego style.
    let store = new LayerStyleStore();
    const initialValue = store.getPolygonGradualSymbol();
    if (initialValue != null && initialValue.reguly !== undefined && initialValue.reguly.length !== 0) {
      let buffer = store.getPolygonGradulSymbolBuffer();
      for (let i = 0; i < initialValue.reguly.length; ++i) {
        if (i === 0) {
          this.selectedAttribute = initialValue.reguly [i].filtr.atrybut;
          this.selectedGradualSymbolAttribute = initialValue.reguly [i].filtr.atrybut;
        }
        buffer.push({
          from: initialValue.reguly[i].filtr.wartoscMin,
          to: initialValue.reguly[i].filtr.wartoscMax,
          fillColor: initialValue.reguly[i].sygnatura.wypelnienie.kolor,
          design: initialValue.reguly[i].sygnatura.wypelnienie.obraz,
          designFileSaved: initialValue.reguly[i].sygnatura.wypelnienie.obraz != null && initialValue.reguly[i].sygnatura.wypelnienie.obraz.length > 0,
          designFileBuffer: null,
          strokeStyle: initialValue.reguly[i].sygnatura.obrys.kreskowanie,
          strokeSize: initialValue.reguly[i].sygnatura.obrys.szerokosc,
          strokeColor: initialValue.reguly[i].sygnatura.obrys.kolor,
          styleDataErrors: {
            strokeSizeEmpty: false,
            strokeSizeNotInRange: false,
            incorrectFileFormat: false,
            fromEmpty: false,
            fromLowerThanToLastStep: false,
            toEmpty: false,
            toLowerThanFrom: false
          }
        });
      }
    }
    this.setUniqueValuesReactive();
    this.setTooltips();
  },
  updated() {
    this.setSortTooltips();
  },
  watch:{
    selectedGradualSymbolAttribute: function(value) {
        if(value===null){
          VueScrollTo.scrollTo({container:'body',easing: "ease"});
        }
      },
    selectedAttributeNotSuitableForClassification: function(value) {
        if(value){
          VueScrollTo.scrollTo({container:'body',easing: "ease"});
        }
      }
  },
  methods: {
    classify() {
      if (this.amountOfClasses === "") {
        this.classifyDataErrors.amountOfClassNotInRange = false;
        this.classifyDataErrors.amountOfClassesEmpty = true;
      } else {
        this.classifyDataErrors.amountOfClassesEmpty = false;
        if (this.amountOfClasses < 1 || this.amountOfClasses > 255) {
          this.classifyDataErrors.amountOfClassNotInRange = true;
        } else {
          this.classifyDataErrors.amountOfClassNotInRange = false;
        }
      }
      if (this.method === null) {
        this.classifyDataErrors.methodEmpty = true;
      } else {
        this.classifyDataErrors.methodEmpty = false;
      }
      if (this.selectedAttribute === null) {
        this.classifyDataErrors.attributeEmpty = true;
      } else {
        this.classifyDataErrors.attributeEmpty = false;
      }
      let classifyValidate =
        !this.classifyDataErrors.amountOfClassesEmpty &&
        !this.classifyDataErrors.amountOfClassNotInRange &&
        !this.classifyDataErrors.methodEmpty &&
        !this.classifyDataErrors.attributeEmpty;
      this.selectedAttributeNotSuitableForClassification = false;
      if (classifyValidate === true) {
        this.loading = true;
        var vm = this;
        this.selectedGradualSymbolAttribute = this.selectedAttribute;
        let store = new LayerStyleStore();
        this.lastRequestTimestamp = getTimestamp();
        var api = new ApiStyle();
        api
          .getKlasyfikacja({
            control: vm.lastRequestTimestamp,
            field: vm.selectedGradualSymbolAttribute,
            layer: vm.layerId,
            n_klas: vm.amountOfClasses,
            metoda: vm.method
          })
          .then(function(response) {
            vm.showError(false, null);
            if (response.body.control === vm.lastRequestTimestamp.toString()) {
              let buffer = store.getPolygonGradulSymbolBuffer();
              buffer.clear();
              if (response.body.breaks.length !== 0) {
                var colorsGradients = getColorsGradients(
                  vm.minColor,
                  vm.maxColor,
                  parseInt(response.body.breaks.length)
                );
                for (var i = 0; i < response.body.breaks.length; ++i) {
                  buffer.push({
                    from: roundNumber(response.body.breaks[i - 1 < 0 ? 0 : i - 1], 4),
                    to: roundNumber(response.body.breaks[i], 4),
                    fillColor: colorsGradients[i],
                    design: null,
                    designFileSaved: false,
                    designFileBuffer: null,
                    strokeStyle: [1],
                    strokeSize: 3,
                    strokeColor: colorsGradients[i],
                    styleDataErrors: {
                      lineStyleEmpty: false,
                      lineWidthEmpty: false,
                      lineWidthNotInRange: false,
                      strokeSizeEmpty: false,
                      strokeSizeNotInRange: false,
                      fromEmpty: false,
                      fromLowerThanToLastStep: false,
                      toEmpty: false,
                      toLowerThanFrom: false
                    }
                  });
                }
              }
              vm.setUniqueValuesReactive();
            }
          })
          .catch(function(err) {
            if(checkErrorMessage(err, 400, 'field not suitable')){
              vm.showError(false, null);
              vm.selectedAttributeNotSuitableForClassification = true;
            } else {
              vm.showError(true, 'Podczas klasyfikacji wystąpił błąd. Spróbuj ponownie później.');
            }
            let buffer = store.getLineGradulSymbolBuffer();
            buffer.clear();
          }).finally(function() {
            vm.setUniqueValuesReactive();
            setTimeout(() => { vm.loading = false; }, 0);
          });
      }
    },
    deleteRow(entry) {
      if (this.attributeValues != null) {
        let store = new LayerStyleStore();
        let buffer = store.getPolygonGradulSymbolBuffer();
        buffer.remove(entry);
        this.setUniqueValuesReactive();
      }
    },
    updateValue() {
      let emitValue = {
        reguly: []
      };
      let store = new LayerStyleStore();
      let buffer = store.getPolygonGradulSymbolBuffer();
      for (let i = 0; i < buffer.count(); ++i) {
        const bufferItem = buffer.get(i);
        let operator = "..";
        if (i === 0) {
          operator = "<=";
        } else if (i === this.attributeValues.length - 1) {
          operator = ">=";
        }
        emitValue.reguly.push({
          filtr: {
            atrybut: this.selectedGradualSymbolAttribute,
            operator: operator,
            wartoscMin: bufferItem.from ? parseFloat(bufferItem.from) : null,
            wartoscMax: bufferItem.to ? parseFloat(bufferItem.to) : null
          },
          sygnatura: {
            obrys: {
              kolor: bufferItem.strokeColor,
              kreskowanie: bufferItem.strokeStyle,
              szerokosc: bufferItem.strokeSize ? parseInt(bufferItem.strokeSize) : null
            },
            wypelnienie: {
              kolor: bufferItem.fillColor,
              kreskowanie: bufferItem.lineStyle ? parseInt(bufferItem.lineStyle) : null,
              szerokosc: bufferItem.lineWidth
            }
          }
        });
      }
      store.setPolygonGradualSymbol(emitValue);
      this.$emit('updated');
    },
    setUniqueValuesReactive() {
      let store = new LayerStyleStore();
      let buffer = store.getPolygonGradulSymbolBuffer();
      if(buffer.any()) {
        const currentIndex = (this.currentPage - 1) * this.elementsPerPage;
        this.attributeValues = buffer.get(currentIndex, currentIndex + this.elementsPerPage);
        this.elementsCount = buffer.count();
      } else {
        this.attributeValues = [];
        this.elementsCount = 0;
      }
    },
    changePage(value) {
      this.currentPage = value;
      this.setUniqueValuesReactive();
    },
    validate() {
      this.updateValue();
      var vm = this;
      let store = new LayerStyleStore();
      let buffer = store.getPolygonGradulSymbolBuffer();
      let bufferArray = buffer.get();
      bufferArray.forEach(x =>
        Object.keys(x.styleDataErrors).forEach(
          y => (x.styleDataErrors[y] = false)
        )
      );
      this.classifyDataErrors.attributeEmpty = false;
      if(buffer.count() !== 0){
        for (let i = 0; i < buffer.count(); ++i) {
          const bufferItem = buffer.get(i);
          if (i !== 0) {
            if (bufferItem.from === "") {
              bufferItem.styleDataErrors.fromEmpty = true;
            } else if (parseFloat(bufferItem.from) < parseFloat(buffer.get(i - 1).to)) {
              this.attributeValues[i].styleDataErrors.fromLowerThanToLastStep = true;
            }
            if (bufferItem.to === "") {
              bufferItem.styleDataErrors.toEmpty = true;
            } else if (bufferItem.to < bufferItem.from) {
              bufferItem.styleDataErrors.toLowerThanFrom = true;
            }
          }
          if (bufferItem.lineStyle === null) {
            bufferItem.styleDataErrors.lineStyleEmpty = true;
          }
          if (bufferItem.lineWidth === "") {
            bufferItem.styleDataErrors.lineWidthEmpty = true;
          } else if (parseInt(bufferItem.lineWidth) < 1 || parseInt(bufferItem.lineWidth) > 255) {
            bufferItem.styleDataErrors.lineWidthNotInRange = true;
          }
          if (bufferItem.strokeStyle !== null) {
            if (bufferItem.strokeSize === "") {
              bufferItem.styleDataErrors.strokeSizeEmpty = true;
            } else if (parseInt(bufferItem.strokeSize) < 1 || parseInt(bufferItem.strokeSize) > 255) {
              bufferItem.styleDataErrors.strokeSizeNotInRange = true;
            }
          }
          buffer.set(bufferItem, i);
        }
        this.setUniqueValuesReactive();
      } else {
        this.classifyDataErrors.attributeEmpty = true;
      }
      return this.classifyDataErrors.attributeEmpty || bufferArray.some(x =>
        Object.keys(x.styleDataErrors).some(y => x.styleDataErrors[y] === true)
      );
    },
    fileChanged(event, row) {
        let files = event.target.files;
        let vm = this;
        if (files.length) {
          if(files[0].type !== 'image/png'){
            this.setFileValue(row, null, true);
          } else {
            getBase64Image(files[0]).then(result => {
              vm.setFileValue(row, result, false);
            }, error => {
              vm.setFileValue(row, null, true);
            });
          }
        } else {
          this.setFileValue(row, null, false);
        }
      },
      setFileValue(row, file, error){
        row.designFileSaved = false;
        row.design = file;
        row.styleDataErrors.incorrectFileFormat = error;
      },
      showError(show, errorMessage) {
        if(this.size === 'lg' || show === false){
          this.$emit('errorMessage', { show: show, errorMessage: errorMessage });
        } else {
          this.$refs.errorModal.show(errorMessage);
        }
      },
      setTooltips() {
        var paginationButtons = Array.from(document.getElementsByClassName("page-item"));

        var firsts = paginationButtons.filter(pb => pb.innerText.indexOf("«") != -1);
        var previous = paginationButtons.filter(pb => pb.innerText.indexOf("‹") != -1);
        var nexts = paginationButtons.filter(pb => pb.innerText.indexOf("›") != -1);
        var lasts = paginationButtons.filter(pb => pb.innerText.indexOf("»") != -1);

        firsts.forEach(item => item.title = "Pierwsza");
        previous.forEach(item => item.title = "Poprzednia");
        nexts.forEach(item => item.title = "Następna");
        lasts.forEach(item => item.title = "Ostatnia");
      },
      setSortTooltips() {
        var sortButtons = Array.from(document.getElementsByClassName("sorting"));
        sortButtons.forEach(item => item.title = "Sortuj");
      }
  },
  components: {
    ColorPicker,
    ErrorModal,
    LoadingOverlay,
    VueScrollTo
  }
};
</script>